export default String.raw`

{% assign pageIdString = page.PageId | ToString -%}
{% assign formalContent = config.TOS.FormalContents[pageIdString] -%}
{% assign fileCount = formalContent.Files | Size -%}

{% include 'partials/common/date-format.html' -%}

<article class="formal-content">
    {% if formalContent.Id > 0 %}
        <section class="content">
            <section class="content__header">
                <h2>{{ formalContent.Name }}</h2>
                <span class="date">
                    <span class="date__text">{{ translations.PublishingDate }}:</span>
                    <time datetime="{{ formalContent.PublishedDate | Date: 'yyyy-MM-dd HH:mm:ss' }}">{{ formalContent.PublishedDate | Date:dateFormat }}</time>
                </span>
            </section>
        {{ formalContent.ContentHtml }}
        </section>
    {% endif %}
    {% if formalContent.ContentPdfUrl or fileCount > 0 %}
        <aside class="files">
            <span class="files__title">{{ translations.FilesToDownload }}:</span>
            {% if formalContent.ContentPdfUrl %}
                        {% capture contentPdfHref -%}{% include 'partials/common/user-link.html', userLink: formalContent.ContentPdfUrl -%}{% endcapture -%}
                        <a aria-label="formalContent" href="{{ contentPdfHref }}" target="_blank" rel="noopener noreferrer">
                            <i class='file-icon'></i>
                            {{ formalContent.Name }}
                        </a>
            {% endif -%}
            {% if fileCount > 0 %}
                {% for file in formalContent.Files %}
                        {% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
                        <a aria-label="file" href="{{ fileHref }}" target="_blank" rel="noopener noreferrer">
                            <i class='file-icon'></i>
                            {{ file.Name }}
                        </a>
                {% endfor %}
            {% endif %}
        </aside>
    {% endif %}
</article>
`